import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Employee Asset Leaderboard',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              sort: {
                by: {
                  '#': {
                    '@': 'ownedAssets',
                  },
                },
                descending: true,
              },
              filter: {
                '>': [
                  {
                    '#': {
                      '@': 'ownedAssets',
                    },
                  },
                  0,
                ],
              },
              target: 'ent:!personnel:!employee',
              quantity: 10,
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      employee: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      jobTitle: {
                        '{}': {
                          value: {
                            '@': 'jobTitle',
                          },
                        },
                      },
                      assetCount: {
                        '{}': {
                          value: {
                            '#': {
                              '@': 'ownedAssets',
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                jobTitle: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!job_title',
                  },
                  target: 'dim::!job_titles',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                ownedAssets: {
                  ref: {
                    attr: 'attr:ent#!innovation_assets#!innovation_asset:!owner',
                  },
                  target: 'ent:!innovation_assets:!innovation_asset',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'employee',
                  direct: {
                    '{}': {
                      name: 'Employee',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'assetCount',
                  direct: {
                    '{}': {
                      name: 'Innovation Assets',
                      type: 'INT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      employee: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      assetCount: {
                        '{}': {
                          value: {
                            '#': {
                              '@': 'assets',
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                assets: {
                  target: 'ent:!innovation_assets:!innovation_asset',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
